import { IApplication } from "../../Interfaces/Application/IApplication";
import {
  SET_DEAL_STATS,
  SET_APP_STATUSES,
  SET_LOCATIONS,
  SET_STATES,
  SET_EMPLOYEES,
  SET_EDITING_APP,
  SET_CUSTOM_FIELDS,
  SET_INITIAL_LOAD_COMPLETE,
  UPDATE_EDITING_APP,
  SET_HOUSING_STATUSES,
  SET_CUSTOMER_ROLES,
  SET_INCOME_PERIODS,
  SET_INCOME_TYPES,
  SET_JOB_CODES,
  SET_WORK_SHIFTS,
  SET_JOB_TYPES,
  SET_QUOTE_PAYMENT_INFO,
  SET_EMPLOYEE_ROLES,
  SET_LOADING,
  SET_MARITAL_STATUSES,
  SET_APP_DIRTY,
  SET_QUOTE_PAY_TYPES,
  SET_CLEAR_SERVER_MESSAGE,
  SET_SERVER_MESSAGE,
  ApplicationDispatch,
  ApplicationState,
  UPDATE_BUDGET,
  UPDATE_APPLICATION_QUOTE_USE_VEHICLE,
  CREATE_APPLICATION_SUCCESS,
  UPDATE_CUSTOMER_CREDIT,
  ADD_CO_APPLICANT,
  UPDATE_CREDIT_APP_FORM_CONFIGURATIONS_SUCCESS,
  GET_DEALERTRACK_APPLICATION_DATA_SUCCESS,
  SET_APPLICANT_CREDIT_APP_FORM_CONFIG,
  SET_CO_APPLICANT_CREDIT_APP_FORM_CONFIG,
  GET_DEALERTRACK_APPLICATION_HISTORY_SUCCESS,
  LOAD_LIBRARY_SUCCESS,
  UPDATE_EMPLOYEE_AVAILABILITY_STATUS_SUCCESS_ACTION,
  GET_APPLICATION_CHAT_SUCCESS,
  GET_700_CREDIT_TRANSACTION_ID,
  GET_APPLICATION_SCORE,
  UPDATE_APP_LOCK,
  CREATE_APPLICATION_FROM_DEALER_FORM_SUCCESS,
  SET_DISABLED_APP_STATUSES,
  SET_APP_STATUS_WORLFLOWS,
  UPDATE_KEY_FACTOR_VALIDATION_RESULTS
} from "./types";
import { IDealStats } from "../../Interfaces/IDealStats";
import { IAppStatus } from "../../Interfaces/Application/IAppStatus";
import { IEmployee } from "../../Interfaces/Admin/IEmployee";
import { massageApp } from "../../utils/appUtils";
import { IState } from "../../Interfaces/Common/IState";
import { ICustomField } from "../../Interfaces/Common/ICustomField";
import { IHousingStatus } from "../../Interfaces/Customer/IHousingStatus";
import { ICustomerRole } from "../../Interfaces/Customer/ICustomerRole";
import { IJobCode } from "../../Interfaces/Common/IJobCode";
import { IIncomePeriod } from "../../Interfaces/Common/IIncomePeriod";
import { IIncomeType } from "../../Interfaces/Common/IIncomeType";
import { IJobType } from "../../Interfaces/Common/IJobType";
import { IWorkShift } from "../../Interfaces/Common/IWorkShift";
import { IQuote } from "../../Interfaces/Common/IQuote";
import { IMaritalStatus } from "../../Interfaces/Common/IMaritalStatus";
import { IQuotePaymentInfo } from "../../Interfaces/Common/IQuotePaymentInfo";
import { IEmployeeRole } from "../../Interfaces/Admin/IEmployeeRole";
import { canUpdateApp } from "../../utils/appUtils";
import { IQuotePayType } from "../../Interfaces/Common/IQuotePayType";
import { AppState } from '../../store/rootReducer';
import { queryCache } from "react-query";
import { postData, fetchData, putData } from "../../Data/fetch";
import { toFixedNumber } from "../../utils/utils";
import { setQueryApplication } from "../../Data/ApplicationData";
import { BusinessRulesEngine } from "../../Data/BusinessRulesData";
import debounce from "lodash/debounce";
import { ApplicationBudget } from "../../Data/ApplicationBudgetData";
import produce from "immer";
import deepEqual from "deep-equal";
import { ICustomerCredit } from "../../Interfaces/Customer/ICustomerCredit";
import { IAppCustomer } from '../../Interfaces/Application/IAppCustomer';
import { IDealerDecisionData } from "../../Interfaces/Common/IDealerDecisionData";
import { IDealerTrackAnalystComments } from "../../Interfaces/Common/IDealerAnalystComments";
import { IIndirectDealerQuoteBaseData, IDealertrackDealerDecisionData } from '../../Data/IDealertrackDealerDecisionData';
import { IDealerServiceAppHistoryItems } from '../../Interfaces/Common/IDealerServiceAppHistory';
import { ILookupItems } from '../../Interfaces/ILookupItems';
import { IApplicationChat } from "../../Interfaces/Application/IApplicationChat";
import { IEntityCustomField } from "../../Interfaces/Application/IEntityCustomField";
import { DealerServiceState } from "../dealerService/reducer";
import { setDealerServiceState } from "../dealerService/actions";
import { IApplicationCustomerMergeInfo } from "../../Interfaces/Common/IApplicationCustomerMergeInfo";
import { IUnmergeApplicationOptions } from "../../Interfaces/Application/IUnmergeApplication";
import {
  Application,
  ApplicationPerformanceEvaluationRequest,
  hasValue,
  PerformanceEvaluationRequest,
  PerformanceIndicatorEvaluationResult, Vehicle
} from "@amsanalytics/react-shared-library";
import { IApplicationScore } from "../../Interfaces/Application/IApplicationScore";
import { updateFinanceQuoteErrorsSuccess, updateLeaseQuoteErrorsSuccess } from "../Notifications/actions";
import { DealerApplicationSubmission } from "../../Interfaces/DealerApplication/DealerApplicationSubmission";
import { ICopyAppOptions } from "../../Interfaces/Application/ICopyAppOptions";
import { ApplicationPerformanceIndicatorEvaluationResult } from "@amsanalytics/react-shared-library";
import { IUpdateAppQuoteCarValues } from "../../Interfaces/Application/IUpdateAppQuoteCarValues";
import { ApplicationFormResult } from "../../Components/Applications/ApplicationConfiguration/ApplicationConfiguration";
import { IApplicationStatusWorkflow } from "../../Interfaces/Application/IApplicationStatusWorkflowItem";
import { getAppQuoteByType } from "../../Components/Quoters/IndirectQuoter/IndirectQuoterUtils";
import { IndirectQuoteType } from "../../Data/IndirectQuoteType";
import {Organization} from "@amsanalytics/react-shared-library/build/Models/Organization";
import { IStipulationCategory } from "../../Interfaces/StipulationTypes";
import {ApplicationAndDealerDecisionData} from "../../Interfaces/Application/ApplicationAndDealerDecisionData";


export const clearServerMessage = () => {
  return (dispatch: ApplicationDispatch) => {
    try {
      dispatch({ type: SET_CLEAR_SERVER_MESSAGE });
    } catch (err) {
      throw err;
    }
  };
};

export const getDealStats = () => {
  return async (dispatch: ApplicationDispatch) => {
    try {
      // for now, we're getting apps for all locations.
      const data = await fetchData(`api/stats`, dispatch);
      const stats: IDealStats = {
        OpenDeals: data["Open Deals"],
        OpenDealsMTD: data["Open MTD"],
        ClosedToday: data["Closed Today"],
        ClosedMTD: data["Closed MTD"],
      };

      dispatch({ type: SET_DEAL_STATS, payload: stats });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

export const mergeApps = (applicantsToMerge: IApplicationCustomerMergeInfo[]) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url: string = `api/Application/mergeapp`;
      const response = await postData(url, applicantsToMerge);
      if (response.error) {
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: true, message: response.error },
        });
        return { success: false, newApplicationId: undefined };
      }
      else {
        loadApps();
        return { success: true, newApplicationId: response as string };
      }
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
      return { success: false, newApplicationId: undefined };
    }
  };
};

export const unmergeApps = (unmergeOptions: IUnmergeApplicationOptions) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url: string = `api/application/unmergeapp`;
      const response = await postData(url, unmergeOptions);
      if (response.error) {
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: true, message: response.error },
        });
        return { success: false, newActiveApplicationId: undefined };
      }
      else {
        loadApps();
        return { success: true, newActiveApplicationId: response as string };
      }

    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
      return { success: false, newApplicationId: undefined };
    }
  };
};

export const copyApplication = (copyOptions: ICopyAppOptions) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url: string = `api/application/copyapp`;
      const response = await postData(url, copyOptions);
      if (response.error) {
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: true, message: response.error },
        });
        return { success: false, newActiveApplicationId: undefined };
      }
      else {
        loadApps();
        return { success: true, newActiveApplicationId: response as string };
      }

    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
      return { success: false, newApplicationId: undefined };
    }
  };
};

export const createApp = (application: Application) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url: string = `api/Application/create`;
      const app = {
        ...application,
        customers: application.customers.map((c) => {
          return {
            ...c,
            previousCarCredit: c.previousCarCredit,
          };
        })
      };
      // Endpoint expects a list of applications.
      const newAppInfo = await postData(url, app);
      dispatch({
        type: CREATE_APPLICATION_SUCCESS,
        payload: newAppInfo,
      });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

// Create application via the Dealer Application form
export const createAppFromDealerForm = (dealerApplication: DealerApplicationSubmission) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url: string = `api/Application/createFromDealerApp`;
      // Endpoint expects a the dealer application form.
      const response = await postData(url, dealerApplication);
      if (response.error) {
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: true, message: "There was an issue saving your application." },
        });
      }
      else {
        dispatch({
          type: CREATE_APPLICATION_FROM_DEALER_FORM_SUCCESS,
          payload: { applicationId: response.applicationId as string },
        });
      }

    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};


// Updates the client's form configuration.
export const updateApplicationFormConfigurations = (creditAppFormConfigurationDetails: ApplicationFormResult) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url: string = `api/Application/configuration`;
      // Endpoint expects the clientId and a stringified configuration object.
      const result = await postData(url, {
        applicantCreditAppFormConfig: JSON.stringify(creditAppFormConfigurationDetails.applicantCreditAppFormConfiguration),
        coApplicantCreditAppFormConfig: JSON.stringify(creditAppFormConfigurationDetails.coApplicantCreditAppFormConfiguration),
        customFields: creditAppFormConfigurationDetails.customFields
      });
      dispatch({
        type: UPDATE_CREDIT_APP_FORM_CONFIGURATIONS_SUCCESS,
        payload: {
          creditAppFormConfigurationDetails
        } as any
      });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

export const getQuotePaymentInfo = (quote: IQuote) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url: string = `api/score/paymentinfo`;
      const paymentInfo: IQuotePaymentInfo = await postData(url, quote);

      dispatch({ type: SET_QUOTE_PAYMENT_INFO, payload: paymentInfo });

      // Make sure that the application is editable by this user.
      const editingApp = getState().applications.editingApp;
      const user = getState().applications.loggedInUser?.employee;
      if (editingApp && user && canUpdateApp(editingApp, user)) {
        const oldPayment =
          editingApp?.applicationQuotes?.find((x) => x.quoteId === quote.id)
            ?.quote.payment || undefined;
        const newPayment = toFixedNumber(paymentInfo?.payment, 2);
        if (oldPayment !== newPayment) {
          const modifiedApp = produce(editingApp, (editingApp) => {
            const q = editingApp.applicationQuotes.find(
              (x) => x.quoteId === quote.id
            );
            if (q) {
              q.quote.payment = newPayment;
            }
          });
          dispatch({ type: UPDATE_EDITING_APP, payload: modifiedApp });
        }
      }
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

export const scoreApp = () => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const app: IApplication = getState().applications.editingApp!;
      const customFields: ICustomField[] = getState().applications.customFields;
      const url: string = `api/score/rescore`;
      let appPost: IApplication = await postData(url, app);
      appPost = massageApp(appPost, customFields);

      dispatch({ type: UPDATE_EDITING_APP, payload: appPost });
      const underwriterAppQuote = getAppQuoteByType(appPost, IndirectQuoteType.Underwriter);
      const scoreJson =
        underwriterAppQuote?.quote?.scoreJson &&
        JSON.parse(underwriterAppQuote?.quote?.scoreJson || "");
      if (scoreJson?.warning) {
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: false, message: scoreJson.warning },
        });
      }
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

export const showErrorMessage = (error: string) => {
  return (dispatch: ApplicationDispatch) => {
    try {
      //const app: IApplication = getState().applications.editingApp;
      //dispatch({ type: SET_EDITING_APP, payload: app.id });
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: error },
      });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

export const cancelAppChanges = () => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      dispatch({ type: SET_LOADING, payload: true });
      await queryCache.refetchQueries("application");
      // const app: IApplication = getState().applications.editingApp!;
      // dispatch({ type: SET_EDITING_APP, payload: app });
      dispatch({ type: SET_APP_DIRTY, payload: false });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    } finally {
      dispatch({ type: SET_LOADING, payload: false });
    }
  };
};

export const loadApps = () => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      dispatch({ type: SET_LOADING, payload: true });
      const customFields: ICustomField[] = await fetchData(
        "api/customfield",
        dispatch
      );

      dispatch({ type: SET_LOADING, payload: false });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

export const doInitialLoad = () => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      // fetch all in parallel
      const statesPromise: Promise<IState[]> = fetchData("api/state", dispatch);
      const employeesPromise: Promise<IEmployee[]> = fetchData(
        "api/employee",
        dispatch
      );
      const housingStatusesPromise: Promise<IHousingStatus[]> = fetchData(
        "api/housingstatus",
        dispatch
      );
      const locationsPromise: Promise<Organization[]> = fetchData(
        "api/location",
        dispatch
      );
      //const noteTypes: INoteType[] = await fetchData("api/notetype");
      const customerRolesPromise: Promise<ICustomerRole[]> = fetchData(
        "api/customerrole",
        dispatch
      );
      const appStatusesPromise: Promise<IAppStatus[]> = fetchData(
        "api/appstatus",
        dispatch
      );
      const applicationStatusWorkflowPromise: Promise<IApplicationStatusWorkflow[]> = fetchData(
        "api/ApplicationStatusWorkflow",
        dispatch
      )
      // employment lookup tables.
      const iperiodsPromise: Promise<IIncomePeriod[]> = fetchData(
        "api/incomeperiod",
        dispatch
      );
      const itypesPromise: Promise<IIncomeType[]> = fetchData(
        "api/incometype",
        dispatch
      );
      const jobCodesPromise: Promise<IJobCode[]> = fetchData(
        "api/jobcode",
        dispatch
      );
      const jobTypesPromise: Promise<IJobType[]> = fetchData(
        "api/jobtype",
        dispatch
      );
      const workShiftsPromise: Promise<IWorkShift[]> = fetchData(
        "api/workshift",
        dispatch
      );
      const customFieldsPromise: Promise<ICustomField[]> = fetchData(
        "api/customfield",
        dispatch
      );
      const quotePayTypesPromise: Promise<IQuotePayType[]> = fetchData(
        "api/quotepaytypes",
        dispatch
      );
      const maritalStatusPromise: Promise<IMaritalStatus[]> = fetchData(
        "api/maritalstatus",
        dispatch
      );
      const employeeRolesPromise: Promise<IEmployeeRole[]> = fetchData(
        "api/employeerole",
        dispatch
      );
      const lookupsPromise: Promise<ILookupItems> = fetchData(
        "api/Lookup",
        dispatch
      );
      const applicantCreditAppFormConfigPromise: Promise<{ applicantCreditAppFormConfig: string }> = fetchData(
        "api/application/applicationFormConfigForClient/applicant",
        dispatch
      );
      const coApplicantCreditAppFormConfigPromise: Promise<{ coApplicantCreditAppFormConfig: string }> = fetchData(
        "api/application/applicationFormConfigForClient/coapplicant",
        dispatch
      );

      // NOTE: The names of the objects in the array must match the name of the variable returned from the promise.
      const [
        states,
        employees,
        housingStatuses,
        locations,
        customerRoles,
        appStatuses,
        iperiods,
        itypes,
        jobCodes,
        jobTypes,
        workShifts,
        customFields,
        quotePayTypes,
        maritalStatus,
        employeeRoles,
        applicationStatusWorkflows,
        applicantCreditAppFormConfig,
        coApplicantCreditAppFormConfig,
        lookups
      ] = await Promise.all([
        statesPromise,
        employeesPromise,
        housingStatusesPromise,
        locationsPromise,
        customerRolesPromise,
        appStatusesPromise,
        iperiodsPromise,
        itypesPromise,
        jobCodesPromise,
        jobTypesPromise,
        workShiftsPromise,
        customFieldsPromise,
        quotePayTypesPromise,
        maritalStatusPromise,
        employeeRolesPromise,
        applicationStatusWorkflowPromise,
        applicantCreditAppFormConfigPromise,
        coApplicantCreditAppFormConfigPromise,
        lookupsPromise
      ]);

      const sortedStates = states.sort((a, b) =>
        a.abbreviation > b.abbreviation ? 1 : -1
      );
      //const preferredLocation: Organization = locations.find((x) => x.preferred)!;

      dispatch({ type: SET_CUSTOM_FIELDS, payload: customFields });
      dispatch({ type: SET_STATES, payload: sortedStates });
      dispatch({ type: SET_EMPLOYEES, payload: employees });
      dispatch({ type: SET_EMPLOYEE_ROLES, payload: employeeRoles });
      dispatch({ type: SET_LOCATIONS, payload: locations });
      dispatch({ type: SET_APP_STATUSES, payload: appStatuses });
      dispatch({ type: SET_APP_STATUS_WORLFLOWS, payload: applicationStatusWorkflows });
      dispatch({ type: SET_HOUSING_STATUSES, payload: housingStatuses });
      dispatch({ type: SET_MARITAL_STATUSES, payload: maritalStatus });
      dispatch({ type: SET_QUOTE_PAY_TYPES, payload: quotePayTypes });
      dispatch({ type: SET_INCOME_PERIODS, payload: iperiods });
      dispatch({ type: SET_INCOME_TYPES, payload: itypes });
      dispatch({ type: SET_JOB_CODES, payload: jobCodes });
      dispatch({ type: SET_JOB_TYPES, payload: jobTypes });
      dispatch({ type: SET_WORK_SHIFTS, payload: workShifts });
      dispatch({ type: SET_CUSTOMER_ROLES, payload: customerRoles });
      dispatch({ type: SET_INITIAL_LOAD_COMPLETE });
      dispatch({ type: SET_APPLICANT_CREDIT_APP_FORM_CONFIG, payload: applicantCreditAppFormConfig });
      dispatch({ type: SET_CO_APPLICANT_CREDIT_APP_FORM_CONFIG, payload: coApplicantCreditAppFormConfig });
      dispatch({ type: LOAD_LIBRARY_SUCCESS, payload: lookups });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

export const saveApp = (businessRulesEngine: BusinessRulesEngine, userBypassedHardPullRequirement: boolean) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    dispatch({ type: SET_LOADING, payload: true });

    const app: IApplication = getState().applications.editingApp!;
    const user = getState().applications.loggedInUser;
    // const hubConnection = getState().messageHub.hubConnection;

    const originalApplicationStatus = app.appStatus.id;
    try {
      let data: IApplication = await putData(
        `api/application/saveapp/${app.id}?userBypassedHardPullRequirement=${userBypassedHardPullRequirement}`,
        app
      );

      const customFields: ICustomField[] = getState().applications.customFields;
      data = massageApp(data, customFields);

      dispatch({ type: UPDATE_EDITING_APP, payload: data });
      dispatch({ type: SET_APP_DIRTY, payload: false });
      // After a successful save, clear the active unlock (backend re-locks automatically)
      if (app.activeUnlock) {
        dispatch({ type: 'CLEAR_ACTIVE_UNLOCK' as const });
      }
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { message: `Application saved successfully`, isError: false },
      });
      dispatch({ type: SET_LOADING, payload: false });

      // if(hubConnection?.state === HubConnectionState.Connected) {
      //   hubConnection.invoke("setApplicationSaved", app.id)
      // }

      setQueryApplication(data);

      runRulesAfterAppEdited(
        dispatch,
        businessRulesEngine,
        getState().applications,
        getState().dealerService,
        "Save"
      );
    } catch (err) {
      // It reverts the application status because it didn't actually save to the DB anyway
      dispatch({ type: UPDATE_EDITING_APP, payload: { ...app, appStatusId: originalApplicationStatus } })
      dispatch({ type: SET_LOADING, payload: false });
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { message: `Error saving app: ${err}`, isError: true },
      });
    }
  };
};

export const setEditingApp = (app?: IApplication) => {
  return (dispatch: ApplicationDispatch, getState: () => AppState) => {
    dispatch({ type: SET_EDITING_APP, payload: app });
  };
};

export const toggleEditingAppLock = () => {
  return (dispatch: ApplicationDispatch, getState: () => AppState) => {
    const user = getState().applications.loggedInUser?.employee;
    // if (isAdmin(user)) {
    const currentApp = getState().applications.editingApp;
    if (currentApp) {
      // const updatedApp: IApplication = {
      //   ...currentApp,
      //   unlockedBySuperUser: !currentApp.unlockedBySuperUser,
      // };
      dispatch({ type: UPDATE_APP_LOCK, payload: !currentApp.unlockedBySuperUser });
    }
    // } else {
    //   dispatch({
    //     type: SET_SERVER_MESSAGE,
    //     payload: {
    //       message:
    //         "Current user does not have permission to unlock this application.",
    //       isError: false,
    //     },
    //   });
    // }
  };
};

export const updateEditingApp = (
  updatedApp: IApplication,
  businessRulesEngine: BusinessRulesEngine
) => {
  return (dispatch: ApplicationDispatch, getState: () => AppState) => {
    if (!deepEqual(getState().applications.editingApp, updatedApp)) {
      dispatch({ type: UPDATE_EDITING_APP, payload: updatedApp });
      const appState = getState().applications; // Get state after the update, so we can pass to the rules engine.
      const dealerServiceState = getState().dealerService;
      runRulesAfterAppEdited(dispatch, businessRulesEngine, appState, dealerServiceState, "Modify");
    }
  };
};

export const updateBudget = (
  applicationBudget: ApplicationBudget,
  businessRulesEngine: BusinessRulesEngine
) => {
  return (dispatch: ApplicationDispatch, getState: () => AppState) => {
    dispatch({ type: UPDATE_BUDGET, payload: applicationBudget });
    const appState = getState().applications;
    const dealerServiceState = getState().dealerService;
    runRulesAfterAppEdited(dispatch, businessRulesEngine, appState, dealerServiceState, "Modify");
  };
};

/** Runs the Save rules for a change the server saved outside saveApp (a lease Solve). */
export const runRulesAfterServerSave = (businessRulesEngine: BusinessRulesEngine) =>
  (dispatch: ApplicationDispatch, getState: () => AppState) =>
    runRulesAfterAppEdited(dispatch, businessRulesEngine, getState().applications, getState().dealerService, "Save");

export const updateDealerService = (businessRulesEngine: BusinessRulesEngine) => {
  return (dispatch: ApplicationDispatch, getState: () => AppState) => {
    const appState = getState().applications;
    const dealerServiceState = getState().dealerService;
    runRulesAfterAppEdited(dispatch, businessRulesEngine, appState, dealerServiceState, "Modify");
  };
}
export const setApplicationQuoteUseVehicle = (
  applicationQuoteUpdateInfo: {
    applicationQuoteId: string;
    useVehiclePrice: boolean;
  },
  businessRulesEngine: BusinessRulesEngine
) => {
  return (dispatch: ApplicationDispatch, getState: () => AppState) => {
    dispatch({
      type: UPDATE_APPLICATION_QUOTE_USE_VEHICLE,
      payload: applicationQuoteUpdateInfo,
    });
    const appState = getState().applications;
    const dealerServiceState = getState().dealerService;
    runRulesAfterAppEdited(dispatch, businessRulesEngine, appState, dealerServiceState, "Modify");
  };
};

const runRulesAfterAppEdited = debounce(
  (
    dispatch: ApplicationDispatch,
    businessRulesEngine: BusinessRulesEngine,
    appState: ApplicationState,
    dealerServiceState: DealerServiceState,
    action: "Modify" | "Save"
  ) => {
    const result = businessRulesEngine({ action }, appState, dealerServiceState);
    if (result?.errors?.length) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: {
          message: `Error while running business rules after modifying application: ${result.errors.reduce(
            (x, y) => (typeof x === 'string' ? x : x.message) + "\n" + (typeof y === 'string' ? y : y.message),
            ""
          )}`,
          isError: true,
        },
      });
    } else {
      // const dealerDecisionData: IDealertrackDealerDecisionData | IAMSDealerFlowData | null = result.applicationState!.dealertrackDealerDecisionData ? { ...result.applicationState!.dealertrackDealerDecisionData } : null;
      // const updateDealerDecisionData = dealerDecisionData && !deepEqual(result.applicationState?.dealertrackDealerDecisionData, appState.dealertrackDealerDecisionData);
      const editingAppWasUpdated = result.applicationState?.editingApp && !deepEqual(result.applicationState?.editingApp, appState.editingApp);
      if (editingAppWasUpdated) {
        dispatch({
          type: UPDATE_EDITING_APP,
          payload: result.applicationState!.editingApp!,
        });
      }
      // if (updateDealerDecisionData) {
      //   dispatch({
      //     type: GET_DEALERTRACK_APPLICATION_DATA_SUCCESS,
      //     payload: { dealertrackDealerDecisionData: dealerDecisionData! }
      //   })
      // }
      if (result.applicationState) {
        dispatch({ type: SET_DISABLED_APP_STATUSES, payload: result.applicationState.disabledAppStatuses })
        // update list of keyFactorValidationResults if any are returned
        if (result.applicationState.keyFactorValidationResults) {
          dispatch({ type: UPDATE_KEY_FACTOR_VALIDATION_RESULTS, payload: result.applicationState.keyFactorValidationResults });
        }
      }
      if (result.dealerServiceState) {
        dispatch(setDealerServiceState(result.dealerServiceState) as any);
      }
      if (result.notificationsState) {
        dispatch(updateFinanceQuoteErrorsSuccess(result.notificationsState.financeQuoteErrors) as any);
        dispatch(updateLeaseQuoteErrorsSuccess(result.notificationsState.leaseQuoteErrors ?? []) as any);
      }
    }
  },
  1000
);

// Pulls credit for a specific customer.
export const pullCredit = (
  applicationId: string,
  customerId: string,
  usesScoring: boolean,
  forcePull: boolean,
  isHardPull: boolean,
  creditBureaus: string[] | undefined,
  businessRulesEngine: BusinessRulesEngine,
  locationId: string
) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    // Show loading spinner to prevent user from clicking button multiple times.
    dispatch({ type: SET_LOADING, payload: true });

    let url = `api/creditApp/ams700Credit?applicationId=${applicationId}&customerId=${customerId}&forcePull=${forcePull}&isHardPull=${isHardPull}&locationId=${locationId}`;
    if (creditBureaus) {
      url += `&creditBureaus=${creditBureaus}`;
    }

    try {
      const response: { customerCredit: ICustomerCredit } | { message: string } = await fetchData(
        url, dispatch
      );

      if ('message' in response) {
        throw response.message;
      } else {
        dispatch({
          type: UPDATE_CUSTOMER_CREDIT,
          payload: {
            customerCredit: response.customerCredit
          },
        });
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { message: `Pulled credit successfully`, isError: false },
        });
      }
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { message: `Error pulling credit: ${err}`, isError: true },
      });
    } finally {
      // Clear loading spinner.
      dispatch({ type: SET_LOADING, payload: false });
    }
    // Gets the Application Scoring information after credit is pulled
    if (usesScoring) {
      dispatch(getPrimary700CreditTransactionId(applicationId));
      dispatch(getApplicationScore(applicationId, businessRulesEngine));
    }
  };
};

export const addCoApplicant = (coApplicant: IAppCustomer) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      dispatch({
        type: ADD_CO_APPLICANT,
        payload: coApplicant,
      });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  };
};

export const sendDecisionToDealerTrackAndSaveApp = (decisionData: IDealerDecisionData, application: IApplication, userBypassedHardPullRequirement: boolean) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const customFields: ICustomField[] = getState().applications.customFields;
      dispatch({ type: SET_LOADING, payload: true });
      const url = `api/dealerTrack/sendDecision`;
      const applicationAndDealerDecisionData: ApplicationAndDealerDecisionData = {
        application: application,
        dealerDecisionData: decisionData,
        userBypassedHardPullRequirement: userBypassedHardPullRequirement
      };
      
      // Send the decision to DealerTrack
      const result: { acknowledgement: string, updatedApplication: IApplication } = await postData(url, applicationAndDealerDecisionData);
      const massagedApp = massageApp(result.updatedApplication, customFields);
      // If API returns an appStatusId, update the app status on the local app.
        dispatch({
          type: UPDATE_EDITING_APP,
          payload: massagedApp
        });
      dispatch({ type: SET_APP_DIRTY, payload: false });
      dispatch({ type: SET_LOADING, payload: false });
      
      // TODO: see if result was successful.
      await dispatch(getDealerTrackApplicationHistory(decisionData.applicationId)); //refreshes the app history
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: {
          message: 'Decision sent and application saved',
          isError: false,
        },
      });
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({ type: SET_LOADING, payload: false });
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const sendAnalystCommentsToDealerTrack = (dealerTrackAnalystCommentsData: IDealerTrackAnalystComments) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/dealerTrack/sendAnalystComments`;
      const result = await postData(url, dealerTrackAnalystCommentsData);
      await dispatch(getDealerTrackApplicationHistory(dealerTrackAnalystCommentsData.applicationId)); //refreshes the app history
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: {
          message: `Comments sent`,
          isError: false,
        },
      });
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const getDealerTrackApplicationData = (applicationId: string, businessRulesEngine: BusinessRulesEngine) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/Application/DealertrackDealerDecisionData/${applicationId}`;
      const dealertrackDealerDecisionData: IDealertrackDealerDecisionData | { message: string } = await fetchData(url, dispatch);
      if ((dealertrackDealerDecisionData as { message: string }).message !== undefined) {
        console.log((dealertrackDealerDecisionData as { message: string }).message);
      } else {
        dispatch({
          type: GET_DEALERTRACK_APPLICATION_DATA_SUCCESS,
          payload: { dealertrackDealerDecisionData: dealertrackDealerDecisionData as IDealertrackDealerDecisionData }
        });
        const appState = getState().applications;
        const dealerServiceState = getState().dealerService;
        runRulesAfterAppEdited(dispatch, businessRulesEngine, appState, dealerServiceState, "Modify");
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const updateDealerFlowData = (dealerFlowData: IIndirectDealerQuoteBaseData, businessRulesEngine: BusinessRulesEngine) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/Application/updateDealerFlowInfo`;
      const response = await putData(url, dealerFlowData);
      console.log("UPDATE DEALER FLOW RESPONSE", response);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: false, message: 'Successfully updated dealer flow data' },
      });
      const appState = getState().applications;
      const dealerServiceState = getState().dealerService;
      dispatch({
        type: GET_DEALERTRACK_APPLICATION_DATA_SUCCESS,
        payload: { dealertrackDealerDecisionData: dealerFlowData! }
      })
      runRulesAfterAppEdited(dispatch, businessRulesEngine, appState, dealerServiceState, "Modify");
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

// export const getAMSDealerFlowData = (applicationId: string) => {
//   return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
//     try {
//       const url = `api/Application/amsDealerFlowData/${applicationId}`;
//       const dealertrackDealerDecisionData: IAMSDealerFlowData | { message: string } = await fetchData(url, dispatch);
//       if ((dealertrackDealerDecisionData as { message: string }).message !== undefined) {
//         console.log((dealertrackDealerDecisionData as { message: string }).message);
//       } else {
//         dispatch({
//           type: GET_DEALERTRACK_APPLICATION_DATA_SUCCESS,
//           payload: { dealertrackDealerDecisionData: dealertrackDealerDecisionData as IAMSDealerFlowData }
//         });
//       }
//     } catch (err) {
//       window.console.log('unknown error occurred')
//       window.console.log('ERROR__', err);
//       dispatch({
//         type: SET_SERVER_MESSAGE,
//         payload: { isError: true, message: err as string },
//       });
//     }
//   }
// }

export const getDealerTrackApplicationHistory = (applicationId: string) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/Application/DealertrackApplicationHistory/${applicationId}`;
      const dealerServiceAppHistoryItems: IDealerServiceAppHistoryItems | { message: string } = await fetchData(url, dispatch);
      if ((dealerServiceAppHistoryItems as { message: string }).message !== undefined) {
        console.log((dealerServiceAppHistoryItems as { message: string }).message);
      } else {
        dispatch({
          type: GET_DEALERTRACK_APPLICATION_HISTORY_SUCCESS,
          payload: { dealerServiceAppHistoryItems: dealerServiceAppHistoryItems as IDealerServiceAppHistoryItems }
        });
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}



export const getApplicationChats = (applicationId: string) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/ApplicationChat/ApplicationChats/${applicationId}`;
      const applicationChats: IApplicationChat[] | { message: string } = await fetchData(url, dispatch);
      if ((applicationChats as { message: string }).message !== undefined) {
        console.log((applicationChats as { message: string }).message);
      } else {
        dispatch({
          type: GET_APPLICATION_CHAT_SUCCESS,
          payload: { applicationChats: applicationChats as IApplicationChat[] }
        });
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const getPrimary700CreditTransactionId = (applicationId: string) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/CustomerCredit/GetPrimary700CreditTransactionId/${applicationId}`;
      const result: { transactionId: string } | { message: string } = await fetchData(url, dispatch);
      if ((result as { message: string }).message !== undefined) {
        console.log((result as { message: string }).message);
      } else {
        dispatch({
          type: GET_700_CREDIT_TRANSACTION_ID,
          payload: { creditPullPrimaryTransactionId: (result as { transactionId: string }).transactionId }
        });
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const getApplicationScore = (applicationId: string, businessRulesEngine: BusinessRulesEngine) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/Scoring/GetApplicationScore/${applicationId}`;
      const result: IApplicationScore | { message: string } = await fetchData(url, dispatch);
      if ((result as { message: string }).message !== undefined) {
        console.log((result as { message: string }).message);
      } else {
        if (result !== undefined) {
          dispatch({
            type: GET_APPLICATION_SCORE,
            payload: { applicationScore: result as IApplicationScore }
          });
        }
        const appState = getState().applications;
        const dealerServiceState = getState().dealerService;
        runRulesAfterAppEdited(dispatch, businessRulesEngine, appState, dealerServiceState, "Modify");
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const getNewApplicationScore = (applicationId: string) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: false, message: "Score Requested" },
      });
      const url = `api/Scoring/GetNewScore/${applicationId}`;
      const result: IApplicationScore | { message: string } = await fetchData(url, dispatch);
      if ((result as { message: string }).message !== undefined) {
        console.log((result as { message: string }).message);
      } else {
        if (result !== undefined) {
          dispatch({
            type: GET_APPLICATION_SCORE,
            payload: { applicationScore: result as IApplicationScore }
          });
        }
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: false, message: "Score Received" },
        });
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const updateEmployeeStatus = (statusId: string) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      const url = `api/Employee/setmystatus/${statusId}`;
      const statusUpdate: { success: boolean, error?: string } = await fetchData(url, dispatch);

      if (statusUpdate.success) {
        dispatch({
          type: UPDATE_EMPLOYEE_AVAILABILITY_STATUS_SUCCESS_ACTION,
          payload: { statusId }
        });
      } else {
        dispatch({
          type: SET_SERVER_MESSAGE,
          payload: { isError: true, message: statusUpdate.error! },
        });
      }
    } catch (err) {
      window.console.log('unknown error occurred')
      window.console.log('ERROR__', err);
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    }
  }
}

export const GET_PERFORMANCE_EVALUATION = 'GET_PERFORMANCE_EVALUATION';
export const GET_PERFORMANCE_EVALUATION_SUCCESS = 'GET_PERFORMANCE_EVALUATION_SUCCESS';

export interface GetPerformanceEvaluationAction {
  type: typeof GET_PERFORMANCE_EVALUATION,
  payload: { performanceEvaluationRequest: PerformanceEvaluationRequest }
};
export const getPerformanceEvaluation = (performanceEvaluationRequest: PerformanceEvaluationRequest): GetPerformanceEvaluationAction => {
  return {
    type: GET_PERFORMANCE_EVALUATION,
    payload: { performanceEvaluationRequest }
  }
};

export interface GetPerformanceEvaluationSuccessAction {
  type: typeof GET_PERFORMANCE_EVALUATION_SUCCESS,
  payload: { scoreEditorPerformanceIndicatorEvaluations: PerformanceIndicatorEvaluationResult[] }
};
export const getPerformanceEvaluationSuccess = (scoreEditorPerformanceIndicatorEvaluations: PerformanceIndicatorEvaluationResult[]): GetPerformanceEvaluationSuccessAction => {
  return {
    type: GET_PERFORMANCE_EVALUATION_SUCCESS,
    payload: { scoreEditorPerformanceIndicatorEvaluations }
  }
};

export const GET_APPLICATION_PERFORMANCE_EVALUATION = 'GET_APPLICATION_PERFORMANCE_EVALUATION';
export const GET_APPLICATION_PERFORMANCE_EVALUATION_SUCCESS = 'GET_APPLICATION_PERFORMANCE_EVALUATION_SUCCESS';

export interface GetApplicationPerformanceEvaluationAction {
  type: typeof GET_APPLICATION_PERFORMANCE_EVALUATION,
  payload: { applicationPerformanceRequest: ApplicationPerformanceEvaluationRequest }
};
export const getApplicationPerformanceEvaluation = (applicationPerformanceRequest: ApplicationPerformanceEvaluationRequest): GetApplicationPerformanceEvaluationAction => {
  return {
    type: GET_APPLICATION_PERFORMANCE_EVALUATION,
    payload: { applicationPerformanceRequest }
  }
};

export interface GetApplicationPerformanceEvaluationSuccessAction {
  type: typeof GET_APPLICATION_PERFORMANCE_EVALUATION_SUCCESS,
  payload: { applicationId: string, applicationPerformanceIndicatorEvaluations: ApplicationPerformanceIndicatorEvaluationResult[] }
};
export const getApplicationPerformanceEvaluationSuccess = (applicationId: string, applicationPerformanceIndicatorEvaluations: ApplicationPerformanceIndicatorEvaluationResult[]): GetApplicationPerformanceEvaluationSuccessAction => {
  return {
    type: GET_APPLICATION_PERFORMANCE_EVALUATION_SUCCESS,
    payload: { applicationId, applicationPerformanceIndicatorEvaluations }
  }
};
// Adds the given vehicle to the current application.
export const addVehicleToApplication = (currentApp: IApplication, vehicle: Vehicle, businessRulesEngine: BusinessRulesEngine, useVehicleWhenVehicleChanges: boolean) => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    try {
      dispatch({ type: SET_LOADING, payload: true });
      const url = `api/Vehicle/addToApplication/${currentApp.id}`;
      // Add the vehicle to the application and save changes to DB.
      const result: { updatedAppQuotes: IUpdateAppQuoteCarValues[], newAppStatusId: string | undefined } = await postData(url, vehicle);
      // Update the current application with the new vehicle info, then dispatch it so that the business rules engine can run.
      const updatedApp: IApplication = {
        ...currentApp,
        appStatusId: hasValue(result.newAppStatusId) ? result.newAppStatusId! : currentApp.appStatusId,
        vehicle: { ...vehicle },
        vehicleId: vehicle.id,
        applicationQuotes: currentApp.applicationQuotes.map((aq) => {
          const carSalePrice = vehicle.carPrice || aq.quote.carSalePrice;
          const newQuote: IQuote = {
            ...aq.quote,
            carSalePrice: carSalePrice,
            nadavalue: vehicle.nadaValue,
          };
          const amountToFinance = result.updatedAppQuotes.find((uq) => uq.quoteId.toLowerCase() === aq.quote.id.toLowerCase())?.amountToFinance || aq.quote.amountToFinance;
          return {
            ...aq,
            useVehiclePrice: result.updatedAppQuotes.find((uq) => uq.quoteId.toLowerCase() === aq.quote.id.toLowerCase())?.useVehiclePrice || useVehicleWhenVehicleChanges,
            quote: {
              ...newQuote,
              amountToFinance: amountToFinance,
            },
          };
        }),
        appCustomers: currentApp.appCustomers.map((ac: IAppCustomer) => {
          return {
            ...ac,
            customer: {
              ...ac.customer,
            }
          };
        }),
      };
      // Setting the vehicle price if there is an ApplicationLeaseQuote record
      if (currentApp.applicationLeaseQuote) {
        updatedApp.applicationLeaseQuote = { ...currentApp.applicationLeaseQuote, sellingPrice: vehicle.carPrice };
      }
      // Applying the same values to each quote
      currentApp.financeQuotes.forEach(financeQuote => financeQuote.sellingPrice = vehicle.carPrice);
      dispatch(updateEditingApp(updatedApp, businessRulesEngine));
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: false, message: "Vehicle has been added to the application." },
      });
    } catch (err) {
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { isError: true, message: err as string },
      });
    } finally {
      dispatch({ type: SET_LOADING, payload: false });
    }
  }
};

export const SET_STIPULATION_CATEGORIES = 'SET_STIPULATION_CATEGORIES';

export interface SetStipulationCategoriesAction {
  type: typeof SET_STIPULATION_CATEGORIES,
  payload: { stipulationCategories: IStipulationCategory[] }
};

export const setStipulationCategories = (stipulationCategories: IStipulationCategory[]): SetStipulationCategoriesAction => {
  return {
    type: SET_STIPULATION_CATEGORIES,
    payload: { stipulationCategories }
  }
}

export type ApplicationActions =
  GetPerformanceEvaluationSuccessAction
  | GetApplicationPerformanceEvaluationSuccessAction
  | SetStipulationCategoriesAction;

// ─── Application Unlock (Granular Section-Based) ────────────────────────

export const unlockApplicationSections = (applicationId: string, sections: string[], reason?: string) => ({
  type: 'UNLOCK_APPLICATION_SECTIONS' as const,
  payload: { applicationId, sections, reason },
});

export const unlockApplicationSectionsSuccess = (unlockLog: any) => ({
  type: 'UNLOCK_APPLICATION_SECTIONS_SUCCESS' as const,
  payload: unlockLog,
});

export const unlockApplicationSectionsFailure = (error: string) => ({
  type: 'UNLOCK_APPLICATION_SECTIONS_FAILURE' as const,
  payload: error,
});

export const fetchActiveUnlock = (applicationId: string) => ({
  type: 'FETCH_ACTIVE_UNLOCK' as const,
  payload: { applicationId },
});

export const fetchActiveUnlockSuccess = (unlockLog: any | null) => ({
  type: 'FETCH_ACTIVE_UNLOCK_SUCCESS' as const,
  payload: unlockLog,
});

export const relockApplication = (applicationId: string) => ({
  type: 'RELOCK_APPLICATION' as const,
  payload: { applicationId },
});

export const relockApplicationSuccess = () => ({
  type: 'RELOCK_APPLICATION_SUCCESS' as const,
});

export const clearActiveUnlock = () => ({
  type: 'CLEAR_ACTIVE_UNLOCK' as const,
});

export const moveForwardApp = () => {
  return async (dispatch: ApplicationDispatch, getState: () => AppState) => {
    dispatch({ type: SET_LOADING, payload: true });

    const app = getState().applications.editingApp!;
    try {
      let data: IApplication = await postData(`api/Application/move-forward/${app.id}`, {});
      const customFields = getState().applications.customFields;
      data = massageApp(data, customFields);

      dispatch({ type: UPDATE_EDITING_APP, payload: data });
      dispatch({ type: SET_APP_DIRTY, payload: false });
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { message: 'Application moved forward to Dealer Review successfully', isError: false },
      });
      dispatch({ type: SET_LOADING, payload: false });

      setQueryApplication(data);
    } catch (err: any) {
      dispatch({ type: SET_LOADING, payload: false });
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { message: `Error moving forward: ${typeof err === 'string' ? err : (err?.message ?? JSON.stringify(err))}`, isError: true },
      });
    }
  };
};

export const moveForwardAppFromQueue = (applicationId: string, nextStatusId: string) => {
  return async (dispatch: ApplicationDispatch) => {
    dispatch({ type: SET_LOADING, payload: true });
    try {
      const data: IApplication = await postData(`api/Application/move-forward/${applicationId}`, { nextStatusId });
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { message: 'Application moved forward successfully', isError: false },
      });
      dispatch({ type: SET_LOADING, payload: false });
      dispatch(loadApps());
      return data;
    } catch (err: any) {
      dispatch({ type: SET_LOADING, payload: false });
      dispatch({
        type: SET_SERVER_MESSAGE,
        payload: { message: `Error moving forward: ${typeof err === 'string' ? err : (err?.message ?? JSON.stringify(err))}`, isError: true },
      });
      return null;
    }
  };
};
